export default __webpack_public_path__ + "static/brian-a7b7b548b6db7154d3335a6d078f81e0.png";